import React, { useState } from 'react';

import CPageModule from '../../components/CPageModule';
import { type IMutableTableInternalState } from '../../components/IMutableTableInternalState';
import { type TPandasDataFrameDict } from '../../components/TPandasDataFrameDict';
import Page from '../../components/layout/Page';
import { ETableIds } from '../../enums/ETableIds';
import CMutableTable from './CMutableTable';
import CTable from './CTable';
import CTableBase from './CTableBase';

interface State {
  data: TPandasDataFrameDict;
  tableState: Partial<IMutableTableInternalState>;
}

export function PPlaygroundIndex2() {
  const sampleDict = {
    'Dish Name': {
      '0': 'Apple Pie',
      '1': 'Banana Split'
    },
    'Price (EUR)': {
      '0': '5',
      '1': '5'
    }
  };

  const [state] = useState<State>({ data: sampleDict, tableState: {} });

  return (
    <Page title={'Playground'}>
      <div className={'p-4'}>
        <CPageModule fullWidth>
          <CTableBase
            id={ETableIds.PLAYGROUND_SCAFFOLD}
            data={state.data}
            rowConfig={{
              body: {
                link: () => {
                  return { to: 'https://www.nexdos.de' };
                }
              }
            }}
            columnConfig={[
              {
                header: {
                  render: (context) => <b>{context.value}</b>
                }
              },
              {
                header: {
                  render: (context) => <b>{context.value}</b>
                }
              }
            ]}
            edgeColumnConfig={{
              prefix: {
                body: {
                  render: (context) => <>{context.rowName}</>,
                  onClick: (context) => {
                    alert(`Clicked on Index ${context.rowValues.join(', ')}`);
                  },
                  style: () => {
                    return {
                      textAlign: 'right'
                    };
                  }
                }
              }
            }}
            // renderCoordinates
          />
          <CTable
            id={ETableIds.PLAYGROUND_SHARED}
            data={state.data}
            rowConfig={{}}
            columnConfig={[]}
            edgeColumnConfig={{
              prefix: {
                body: {
                  render: (context) => <>{context.rowName}</>
                }
              }
            }}
          />
          <CMutableTable
            onUpdateInternalState={() => {}}
            id={ETableIds.PLAYGROUND_MUTABLE}
            data={state.data}
            rowConfig={{}}
            columnConfig={[]}
          />
        </CPageModule>
      </div>
    </Page>
  );
}
